import { memo } from "react";

export const PresentationModeIcon = memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" fill="none" viewBox="0 0 18 16">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.371 1.33h15.14M5.586 14.87h6.744M15.714 1.33v9.138c0 .44-.16.863-.444 1.174a1.45 1.45 0 0 1-1.07.487H3.602a1.45 1.45 0 0 1-1.07-.487 1.75 1.75 0 0 1-.444-1.174V1.33"
      ></path>
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.107 4.838a.63.63 0 0 1 .32-.549.62.62 0 0 1 .632.013l3.054 1.89a.63.63 0 0 1 .297.536.64.64 0 0 1-.297.537l-3.054 1.89a.62.62 0 0 1-.866-.218.63.63 0 0 1-.086-.32z"
      ></path>
      <path stroke="#1E1E1E" d="M8.918 12.039v2.52"></path>
    </svg>
  );
});
PresentationModeIcon.displayName = "PresentationModeIcon";

export const TimerIcon = memo(() => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 3.79883V7.99883L10.8 9.39883" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
});
TimerIcon.displayName = "TimerIcon";

export const VotingIcon = memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        stroke="#1E1E1E"
        strokeMiterlimit="10"
        d="M1 8h14v6.86a.14.14 0 0 1-.143.14H1.143A.14.14 0 0 1 1 14.86zM10.625 2.75h2.748c.054 0 .107.044.123.106L15 8M1 8l1.701-5.144a.15.15 0 0 1 .14-.106h2.534"
      ></path>
      <path stroke="#1E1E1E" strokeLinecap="round" strokeMiterlimit="10" d="M11.5 5.375h-7"></path>
      <path
        stroke="#1E1E1E"
        strokeMiterlimit="10"
        d="m5.375 5.375.105-4.338S5.502 1 5.523 1h5.018s.052.028.042.056l.042 4.16"
      ></path>
    </svg>
  );
});
VotingIcon.displayName = "VotingIcon";

export const VideoCallIcon = memo(
  ({ active, numberOfParticipants }: { active: boolean; numberOfParticipants: number }) => {
    return (
      <span style={{ display: "inline-flex", alignItems: "center", position: "relative" }}>
        {numberOfParticipants > 0 && (
          <span
            style={{
              position: "absolute",
              top: -10,
              left: -8,
              zIndex: 1,
              pointerEvents: "none",
            }}
          >
            <svg width="14" height="14" aria-label="Participants">
              <circle cx="7" cy="7" r="7" fill="#00b875" />
              <text x="7" y="10" textAnchor="middle" fontSize="8" fontWeight="bold" fill="#fff" fontFamily="inherit">
                {numberOfParticipants}
              </text>
            </svg>
          </span>
        )}
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" fill="none" viewBox="0 0 19 14">
          <path
            stroke={active ? "#00b875" : "#1E1E1E"}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.785 4.553v4.882l3.783 3.32V1.33zM1.34 1.33h9.56c1.391 0 2.876 1.145 2.876 2.669v7.803a.946.946 0 0 1-.925.952H3.013c-1.58 0-2.515-1.428-2.515-2.856l.01-7.617a.84.84 0 0 1 .197-.676.8.8 0 0 1 .635-.273z"
          />
        </svg>
      </span>
    );
  }
);
VideoCallIcon.displayName = "VideoCallIcon";

export const VideoCallHangupIcon = memo(({ color }: { color: string }) => {
  return (
    <svg width="27" height="13" viewBox="0 0 27 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.4448 8.60481L22.2625 11.7881L16.6923 9.40188L17.4875 6.21901C14.9074 5.34371 12.1105 5.34415 9.53065 6.22027L10.3268 9.40289L4.75742 11.7908L1.57417 8.60859C1.15204 8.1866 0.91484 7.6142 0.914746 7.01732C0.914651 6.42044 1.15167 5.84797 1.57366 5.42584C4.86558 2.51017 9.11076 0.9001 13.5082 0.899404C17.9057 0.898708 22.1514 2.50744 25.4443 5.42206C25.8664 5.84405 26.1036 6.41645 26.1037 7.01333C26.1038 7.61021 25.8668 8.18268 25.4448 8.60481Z"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
VideoCallHangupIcon.displayName = "VideoCallHangupIcon";

export const CommentsIcon = memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" d="M5 6.56h5.901M5 9.445h5.747"></path>
      <path
        fill="#1E1E1E"
        d="M10.241 1.28v-.5zm5 5h.5zm-5 7.599v.5zm-7.407-.007.031-.499-.21-.013-.156.14zm-1.372 1.236.334.372zm-.501-.222h-.5zm5-13.607v-.5zm4.28 0v.5a4.5 4.5 0 0 1 4.5 4.5h1a5.5 5.5 0 0 0-5.5-5.5zm5 5h-.5v2.6h1v-2.6zm0 2.6h-.5a4.5 4.5 0 0 1-4.5 4.5v1a5.5 5.5 0 0 0 5.5-5.5zm-5 5v-.5h-7.28v1h7.28zm-7.28 0v-.5c-.022 0-.03-.002-.096-.006l-.031.5-.031.498c.018.001.094.008.158.008zm-.127-.007-.335-.371-1.372 1.236.335.371.335.372 1.372-1.237zm-1.372 1.236-.335-.371a.2.2 0 0 1 .334.149h-1a.8.8 0 0 0 1.335.594zm-.501-.222h.5V6.279h-1v8.607zm0-8.607h.5a4.5 4.5 0 0 1 4.5-4.5v-1a5.5 5.5 0 0 0-5.5 5.5zm5-5v.5h4.28v-1h-4.28z"
      ></path>
    </svg>
  );
});
CommentsIcon.displayName = "CommentsIcon";

export const CommentsActiveIcon = memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        d="M5.525 7.243h6.612M5.525 10.475h6.439"
      ></path>
      <path
        fill="#1E1E1E"
        d="M17 9.84h.65zM3.099 15.436l.04-.65-.272-.016-.203.182zM1.56 16.819l.434.484zM1 16.57H.35v.001zM11.398 1.325v.65a4.953 4.953 0 0 1 4.952 4.953h1.3c0-3.453-2.8-6.253-6.252-6.253zM17 6.928h-.65V9.84h1.3V6.928zm0 2.913h-.65a4.95 4.95 0 0 1-4.953 4.951v1.3a6.25 6.25 0 0 0 6.253-6.251zm-5.602 5.601v-.65H3.24v1.3h8.157zm-8.157 0v-.65c-.02 0-.02-.001-.102-.006l-.04.649-.041.648c.013.001.108.01.183.01zm-.142-.007-.435-.484-1.538 1.385.435.483.434.483 1.539-1.384zM1.56 16.819l-.435-.483a.314.314 0 0 1 .524.234H1l-.65.001c.001.854 1.012 1.301 1.645.732zM1 16.57h.65V6.928H.35v9.642zm0-9.642h.65a4.953 4.953 0 0 1 4.953-4.953v-1.3A6.253 6.253 0 0 0 .35 6.928zm5.603-5.603v.65h4.795v-1.3H6.603z"
      ></path>
    </svg>
  );
});
CommentsActiveIcon.displayName = "CommentsActiveIcon";
